/*
 * @Author: cmchiu
 * @Date: 2023-04-27 14:47:35
 * @LastEditTime: 2023-05-02 10:36:48
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \IACMP\IACMP_Client\src\views\components\index.js
 *
 */
export { default as ResultLs } from './resultLs.vue'
export { default as DownloadLs } from './downloadLs.vue'
